var common = require("../utiles/common")

module.exports = {
    register: function () {
        document.createElement('single-form')
        ko.components.register('single-form', {
            viewModel: function (params) {
                var $this = this;
                console.debug(params.app)
                $this.$data = params.app;
                $this.unmodufy = params.app.unmodufy?true:false;
                $this.type = params.app.type;
                if(params.disabled){
                    $this.editable = false;
                }else{
                    $this.editable = params.app.editable&&!$this.unmodufy;
                }
                //console.log($this.editable)
                $this.name = params.app.name; 
                $this.value = params.app.value;
                $this.code = params.app.code;
                $this.selectableFields = params.app.selectableFields;
                $this.selectChange = function(){
                    
                }
                //console.log(params)
                switch(params.app.type){
                    case "String":
                    if(params.app.code == "idNumber"){
                        $this.rules = params.app.required?["require","idNumber"]:["idNumber"]
                    }else{
                        $this.rules = params.app.required?["require","global"]:params.app.derivative?[]:["global"];
                    }
                    break;
                    case "Phone":
                    $this.rules = params.app.required?["require","phone"]:["phone"]
                    break;
                    case "Email":
                    $this.rules = params.app.required?["require","email"]:["email"]
                    break;
                    case "Number":
                    $this.rules = params.app.required?["require","number"]:["number"]
                    break;
                    default:
                    $this.rules = params.app.required?["require"]:[]
                }
                if(params.app.metaPropertyRegex){
                    $this.rules.push({regexStr:params.app.regexStr,regexHintMsg:params.app.regexHintMsg})
                }
                if(params.app.metaPropertyLength){
                    $this.rules.push({maxLength:params.app.maxLength,minLength:params.app.minLength})
                }
                
            },
            template: require("./SingleForm.html")
        });
    }
}


//////////////////
// WEBPACK FOOTER
// ./src/template/SingleForm.js
// module id = 95
// module chunks = 0